<template>
  <div :class="['grid gap-4 sm:gap-5 mb-6', gridColumn()]">
    <div
      v-for="category in categoryhome"
      :key="category.id"
      class="group flex flex-col items-center gap-3 p-4 sm:p-5 rounded-xl bg-white dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/50 shadow-sm hover:shadow-md hover:border-blue-200 dark:hover:border-blue-700/50 transition-all duration-200 cursor-pointer"
      style="box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08)"
    >
      <a :href="'/sanpham/' + category.id" class="block w-full">
        <!-- Image: uniform square -->
        <div class="w-full aspect-square rounded-xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800 ring-1 ring-gray-200/50 dark:ring-gray-600/50 group-hover:ring-2 group-hover:ring-blue-300 dark:group-hover:ring-blue-500/50 transition-all duration-200 shadow-sm">
          <img
            :src="'/' + isImagePath(category.hinh_loai)"
            class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            :alt="category.ten_loai"
            loading="lazy"
          />
        </div>
        <!-- Name -->
        <div class="text-center mt-3">
          <h5
            class="text-sm sm:text-base font-semibold text-gray-700 dark:text-gray-200 line-clamp-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors leading-snug capitalize"
          >
            {{ category.ten_loai }}
          </h5>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'
import Button from './Button.vue'
import route from 'ziggy-js'

const props = defineProps(['categoryhome', 'column', 'width'])

const categoryHome = ref(props.categoryhome)
const showAllCategories = ref(false)
const initialRowCount = 12
const categories = ref([])

const gridColumn = () => {
  switch (props.column) {
    case '6':
      return 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6'
    default:
      return 'grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5'
  }
}

const toggleShowAll = () => {
  showAllCategories.value = !showAllCategories.value
  categories.value = showAllCategories.value
    ? categoryHome.value
    : categoryHome.value.slice(0, initialRowCount)
}
const isImagePath = (path) => {
  const imagePathPrefix = 'assets/images'
  const check = path.includes(imagePathPrefix)
  if (check) {
    return path
  }
  return 'storage/' + path
}
onMounted(() => {
  categories.value = categoryHome.value.slice(0, initialRowCount)
})
</script>
